import { Coord } from "../../../types/Interface";
import Compass from "./Compass";


const INITIAL_START_COORD = { x: 400, y: 600 };
const INITIAL_END_COORD = { x: 700, y: 600 };
const INITIAL_RADIAN = Math.PI / 3.5;


export default class CompassFactory {
  static handlePointerMove(This: Compass, coord: Coord) {
    if(!This.pStartCoord) { return };
    const deltaX = coord.x - This.pStartCoord.x;
    const deltaY = coord.y - This.pStartCoord.y;

    if(This.isKnobPressed) This.handleKnobPointerMove(coord)
    else if(This.isNeedleLegPressed) This.handleNeedleLegPointerMove(deltaX, deltaY)
    else if(This.isPencilLegPressed) This.handlePencilLegPointerMove(coord, deltaX, deltaY)
  }
  static handlePointerUp(This: Compass) {
    This.initialStartCoord = { ...This.startCoord };
    This.initialEndCoord = { ...This.endCoord };
    This.isKnobPressed = false;
    This.isNeedleLegPressed = false;
    This.isPencilLegPressed = false;
    This.handleLockActTmprary(false);
    This.handleEventMode(true);
    //This.onUpHandle();
  }
  static resetValues(This: Compass) {
    This.initialStartCoord = INITIAL_START_COORD;
    This.startCoord = INITIAL_START_COORD;
    This.initialEndCoord = INITIAL_END_COORD;
    This.endCoord = INITIAL_END_COORD;
    This.radian = INITIAL_RADIAN;
  }
}